import 'svelte/internal/disclose-version';
import { cn } from "$lib/utils.js";
import { tv } from "tailwind-variants";
import * as $ from 'svelte/internal/client';

export const buttonVariants = tv({
	base: "focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive inline-flex shrink-0 items-center justify-center gap-2 rounded-md text-sm font-medium whitespace-nowrap transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",

	variants: {
		variant: {
			default: "bg-primary text-primary-foreground hover:bg-primary/90 shadow-xs",
			destructive: "bg-destructive hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60 text-white shadow-xs",
			outline: "bg-background hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 border shadow-xs",
			secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 shadow-xs",
			ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
			link: "text-primary underline-offset-4 hover:underline"
		},

		size: {
			default: "h-9 px-4 py-2 has-[>svg]:px-3",
			sm: "h-8 gap-1.5 rounded-md px-3 has-[>svg]:px-2.5",
			lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
			icon: "size-9",
			"icon-sm": "size-8",
			"icon-lg": "size-10"
		}
	},

	defaultVariants: { variant: "default", size: "default" }
});

var root_1 = $.from_html(`<a><!></a>`);
var root_2 = $.from_html(`<button><!></button>`);

export default function Button($$anchor, $$props) {
	$.push($$props, true);

	let variant = $.prop($$props, 'variant', 3, "default"),
		size = $.prop($$props, 'size', 3, "default"),
		ref = $.prop($$props, 'ref', 15, null),
		href = $.prop($$props, 'href', 3, undefined),
		type = $.prop($$props, 'type', 3, "button"),
		restProps = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'class',
			'variant',
			'size',
			'ref',
			'href',
			'type',
			'disabled',
			'children'
		]);

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var a = root_1();

			$.attribute_effect(
				a,
				($0) => ({
					'data-slot': 'button',
					class: $0,
					href: $$props.disabled ? undefined : href(),
					'aria-disabled': $$props.disabled,
					role: $$props.disabled ? "link" : undefined,
					tabindex: $$props.disabled ? -1 : undefined,
					...restProps
				}),
				[
					() => cn(buttonVariants({ variant: variant(), size: size() }), $$props.class)
				]
			);

			var node_1 = $.child(a);

			$.snippet(node_1, () => $$props.children ?? $.noop);
			$.reset(a);
			$.bind_this(a, ($$value) => ref($$value), () => ref());
			$.append($$anchor, a);
		};

		var alternate = ($$anchor) => {
			var button = root_2();

			$.attribute_effect(
				button,
				($0) => ({
					'data-slot': 'button',
					class: $0,
					type: type(),
					disabled: $$props.disabled,
					...restProps
				}),
				[
					() => cn(buttonVariants({ variant: variant(), size: size() }), $$props.class)
				]
			);

			var node_2 = $.child(button);

			$.snippet(node_2, () => $$props.children ?? $.noop);
			$.reset(button);
			$.bind_this(button, ($$value) => ref($$value), () => ref());
			$.append($$anchor, button);
		};

		$.if(node, ($$render) => {
			if (href()) $$render(consequent); else $$render(alternate, false);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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